const actions = {
  FETCH_CLIENTS: 'FETCH_CLIENTS',
  FETCH_ALL_CLIENTS: 'FETCH_ALL_CLIENTS',
  FETCH_CLIENTS_SUCCESS: 'FETCH_CLIENTS_SUCCESS',
  FETCH_SETTINGS: 'FETCH_SETTINGS',
  FETCH_SETTINGS_SUCCESS: 'FETCH_SETTINGS_SUCCESS',
  FETCH_UNASSIGNED_PHARMACIES: 'FETCH_UNASSIGNED_PHARMACIES',
  FETCH_UNASSIGNED_PHARMACIES_SUCCESS: 'FETCH_UNASSIGNED_PHARMACIES_SUCCESS',
  FETCH_UNASSIGNED_PHARMACIES_ERROR: 'FETCH_UNASSIGNED_PHARMACIES_ERROR',
  GET_CLIENT: 'GET_CLIENT',
  GET_CLIENT_SUCCESS: 'GET_CLIENT_SUCCESS',
  ADD_CLIENT: 'ADD_CLIENT',
  EDIT_CLIENT: 'EDIT_CLIENT',
  SAVE_CLIENT: 'SAVE_CLIENT',
  SAVE_CLIENT_SUCCESS: 'SAVE_CLIENT_SUCCESS',
  DELETE_CLIENT: 'DELETE_CLIENT',
  DELETE_CLIENT_SUCCESS: 'DELETE_CLIENT_SUCCESS',
  CHANGE_CLIENT: 'CHANGE_CLIENT',
  ADD_CLIENT_VIEW: 'ADD_CLIENT_VIEW',
  EDIT_CLIENT_VIEW: 'EDIT_CLIENT_VIEW',
  EDIT_VIEW: 'EDIT_VIEW',
  UPDATE_VALUES: 'UPDATE_VALUES',
  FETCH_CLIENTS_BY_ACCOUNT: 'FETCH_CLIENTS_BY_ACCOUNT',
  FETCH_CLIENTS_BY_ACCOUNT_SUCCESS: 'FETCH_CLIENTS_BY_ACCOUNT_SUCCESS',
  fetchClients: (account = '', retrieveAll) => ({
    type: actions.FETCH_CLIENTS,
    account,
    retrieveAll
  }),
  fetchClientsSuccess: (clients, pharmacies, retrieveAll) => ({
    type: actions.FETCH_CLIENTS_SUCCESS,
    clients,
    pharmacies,
    retrieveAll
  }),
  fetchSettings: () => ({
    type: actions.FETCH_SETTINGS,
  }),
  fetchSettingsSuccess: (settings) => ({
    type: actions.FETCH_SETTINGS_SUCCESS,
    settings: settings,
  }),
  fetchUnassignedPharmacies: () => ({
    type: actions.FETCH_UNASSIGNED_PHARMACIES,
  }),
  fetchUnassignedPharmaciesSuccess: (pharmacies) => ({
    type: actions.FETCH_UNASSIGNED_PHARMACIES_SUCCESS,
    pharmacies,
  }),
  fetchUnassignedPharmaciesError: () => ({
    type: actions.FETCH_UNASSIGNED_PHARMACIES_ERROR,
  }),
  getClient: (clientId) => ({
    type: actions.GET_CLIENT,
    clientId: clientId
  }),
  getClientSuccess: (client) => ({
    type: actions.GET_CLIENT_SUCCESS,
    client: client
  }),
  addClient: () => ({
    type: actions.ADD_CLIENT
  }),
  addClientView: (view) => ({
    type: actions.ADD_CLIENT_VIEW,
    view
  }),
  editClientView: (view, save, clientInfo) => ({
    type: save ? actions.SAVE_CLIENT : actions.EDIT_CLIENT_VIEW,
    view,
    clientInfo
  }),
  saveClientSuccess: (client) => ({
    type: actions.SAVE_CLIENT_SUCCESS,
    client
  }),
  editClient: (clientId) => ({
    type: actions.EDIT_CLIENT
  }),
  deleteClient: (clientId) => ({
    type: actions.DELETE_CLIENT,
    clientId
  }),
  deleteClientSuccess: (clientId) => ({
    type: actions.DELETE_CLIENT_SUCCESS,
    clientId
  }),
  updateClientInfo: (clientInfo) => ({
    type: actions.UPDATE_VALUES,
    clientInfo,
  }),
  fetchClientsByAccount: (account = '', retrieveAll) => ({
    type: actions.FETCH_CLIENTS_BY_ACCOUNT,
    account,
    retrieveAll
  }),
  fetchClientsForAccountSuccess: (clients, pharmacies, retrieveAll) => ({
    type: actions.FETCH_CLIENTS_BY_ACCOUNT_SUCCESS,
    clients,
    pharmacies,
    retrieveAll
  }),
};
export default actions;
